import ApiService from './ApiService';

const TriggersService = {
  list: () => ApiService.get('/triggers'),
  create: (trigger) => ApiService.post('/triggers', trigger),
  update: (id, fields) => ApiService.patch(`/triggers/${id}`, fields),
  remove: (id) => ApiService.del(`/triggers/${id}`),
  checkNow: (id) => ApiService.post(`/triggers/${id}/check`),
};

export default TriggersService;
